import React from 'react';

interface Shop {
  id: string | number;
  slug: string;
  name: string;
  webshop_url: string;
}

interface ClientCardProps {
  shop: Shop;
  isActive: boolean;
  isSwitching: boolean;
  isSwitchingTarget: boolean;
  onClick: () => void;
}

const ClientCard: React.FC<ClientCardProps> = ({
  shop,
  isActive,
  isSwitching,
  isSwitchingTarget,
  onClick,
}) => {
  const initial = shop.name?.charAt(0)?.toUpperCase() || 'C';

  return (
    <div
      className={`clientCard ${isActive && !isSwitching ? 'clientCard--active' : ''} ${
        isSwitchingTarget ? 'clientCard--switching' : ''
      } ${isSwitching ? 'clientCard--disabled' : ''}`}
      onClick={onClick}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className='clientCard__avatar'>{initial}</div>
      <div className='clientCard__info'>
        <span className='clientCard__name'>{shop.name}</span>
        <span className='clientCard__url'>{shop.webshop_url || ''}</span>
      </div>
      {isActive && (
        <div className='clientCard__badge'>Active</div>
      )}
      {isSwitchingTarget && (
        <div className='clientCard__loading'>
          <div className='clientCard__spinner' />
        </div>
      )}
    </div>
  );
};

export default ClientCard;
